import * as React from 'react';
import { connect } from 'react-redux';

import LinearProgress from '@material-ui/core/LinearProgress';

import GetUserExplorerRender from './GetUserExplorerRender';
import EmptyData from '../../components/EmptyData/EmptyData';
import UserExplorerMonthSelect from './UserExplorerMonthSelect';

import State from '../../interfaces/states/State';

import ExplorerData from '../../interfaces/ExplorerData';
import DatesAnyArray from '../../interfaces/DatesAnyArray';
import ExplorerCurrentCategory from '../../interfaces/ExplorerCurrentCategory';

import './style.scss';

interface Props {
  userExplorerData: ExplorerData;
  isLoading: boolean;
  isActivityLoading: boolean;
  activityData: DatesAnyArray;
  currentCategory: ExplorerCurrentCategory;
}

function UserExplorer (props: Props) {

  return (
    <section
      className='user-explorer d-flex flex-column'>
      <span className='page-head'>{'User Explorer'}</span>
      {
        props.isActivityLoading ?
          <div className='loader-container'>
            <LinearProgress color='primary' />
          </div> :
          (
            props.activityData.dates ?
              <UserExplorerMonthSelect /> :
              <EmptyData
                message='No dates for selected period' />
          )
      }{
        props.isLoading ?
          <div className='loader-container'>
            <LinearProgress color='primary' />
          </div> :
          (
            props.userExplorerData.data.event.length > 0 ?
              <GetUserExplorerRender
                userExplorerData={props.userExplorerData}
                filteredCategory={props.currentCategory}
              />
              :
              <div>
                {
                  props.isActivityLoading ?
                    null :
                    <div className='user-explorer-message'>
                      <EmptyData
                        message='Please, select tha date to see information about events' />
                    </div>
                }
              </div>
          )
      }
    </section>
  );
  
}

const mapStateToProps = (state: State) => {
  return {
    isLoading: state.userExplorer.isLoading,
    isActivityLoading: state.activity.isLoading,
    userExplorerData: state.userExplorer.userExplorerData,
    activityData: state.activity.activityData,
    currentCategory: state.userExplorer.currentCategory,
  };
};

const mergeProps = (stateProps, dispatchProps, props: Props): Props => {
  return {
    ...stateProps,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
  }, mergeProps
)(React.memo(UserExplorer));
